import { Component } from "./Component";
import { vp } from "../managers/vp";
import { settings } from "../const/Settings";
import { HyDrawer } from "hy-drawer";
var Mode;
(function (Mode) {
    Mode[Mode["mob"] = 0] = "mob";
    Mode[Mode["web"] = 1] = "web";
})(Mode || (Mode = {}));
export class SideMenu extends Component {
    constructor() {
        super(...arguments);
        this._navList = null;
        this.onSlideEnd = () => {
            this.checkState();
        };
    }
    init() {
        this._closeBtn = this.getHtml('close');
        this._contentHtml = this.getHtml('content');
        vp.mediaQueries.onMatches([settings.mediaQueries.mqCollapseMenu], (mq) => {
            this.mode = mq.matches ? Mode.mob : Mode.web;
        });
        this.getHtml('logo').addEventListener('click', () => {
            window.location.href = '/';
        });
        const ua = navigator.userAgent.toLowerCase();
        const isSafari = ua.indexOf('safari') > 0 && ua.indexOf('chrome') < 0;
        const isMobileSafari = isSafari && ua.indexOf('mobile') > 0;
        this._drawer = new HyDrawer(this.html, {
            range: isMobileSafari ? [35, 250] : [0, 250],
            threshold: isSafari ? 0 : 10,
            opened: true,
            persistent: true,
            preventDefault: false,
            mouseEvents: false
        });
        this.update();
        this.checkState();
        this.html.addEventListener('hy-drawer-transitioned', this.onSlideEnd);
        this._closeBtn.addEventListener('click', () => {
            this.close();
        });
        vp.components.forEach({ jsName: 'NavList' }, (navList) => {
            this._navList = navList;
        }, true);
        if (this._mode === Mode.web) {
            this.open();
        }
    }
    set mode(value) {
        this._mode = value;
        this.update();
    }
    update() {
        if (this._drawer) {
            this._drawer.mouseEvents = this._mode !== Mode.web;
            if (this._mode === Mode.web) {
                this.open();
            }
            else {
                this.close();
            }
        }
    }
    checkState() {
        if (!this._drawer.opened) {
            this.html.style.display = 'none';
        }
        if (this._mode === Mode.web) {
            this.html.style.display = 'block';
        }
    }
    close() {
        this._drawer.close();
    }
    open() {
        this.html.style.display = 'block';
        setTimeout(() => {
            this._drawer.open();
            if (this._navList) {
                this._navList.update();
            }
        }, 1);
    }
}
